import React from "react";
import ReactDOM from "react-dom/client";
// Bootstrap LOCAL (bundle), não CDN. Vinha de cdn.jsdelivr.net com hash de
// integrity: qualquer falha de rede — ou hash divergente — fazia o navegador
// descartar o CSS inteiro, e sem `.tab-pane { display:none }` a tela de login
// renderizava os painéis de cadastro E login empilhados. Falha intermitente,
// por usuário, impossível de reproduzir no nosso ambiente. No bundle, o CSS
// carrega junto do app e o app nativo (WebView) deixa de depender de internet
// para se desenhar. Vem ANTES dos nossos estilos, que precisam sobrescrevê-lo.
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/global.css";
import App from "./App";

import "./styles/theme/themes.css";
import './styles/global.css';

// ── Design system (redesign) ────────────────────────────────────────────
// Ordem importa: a fonte e os tokens entram antes da ponte de compatibilidade,
// que reescreve os nomes antigos em cima deles.
import './styles/fonts.css';           // Plus Jakarta Sans, servida pelo app
import './styles/tokens.generated.css'; // GERADO de handoff/tokens.json
import './design/motion.scss';          // keyframes globais + .lv-glass + reduced-motion
import './styles/compat-legacy.css';    // ponte para as telas legadas (sai na Fase 9)

// ── Internacionalização ─────────────────────────────────────────────────
// Importado pelo efeito colateral: inicializa o i18next antes do primeiro render.
import './i18n';

import { initEdgeToEdge } from "./native/edgeToEdge";
import { instalar as instalarTelemetriaDeErros } from "./telemetria/errosDoApp";
import { Capacitor } from "@capacitor/core";

// Marcador estritamente nativo: permite ajustes exclusivos do WKWebView sem
// alterar Android nem Safari/web responsivo.
if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios") {
  document.documentElement.classList.add("platform-ios");
}

// Android 15 edge-to-edge: aplica os insets nativos à WebView e pinta as barras
// com a cor do tema. No-op em iOS/web.
initEdgeToEdge();

// Erros do lado do aparelho (JS, promise, render) e estado da rede da pessoa.
// Antes do render: um erro no primeiro frame também tem de ser visto.
instalarTelemetriaDeErros();

// Lock de escala de texto (decisão de produto v3.7.3): o layout do app é
// calibrado para escala 1.0 — a fonte de acessibilidade do SISTEMA não deve
// re-escalar a WebView (no Android o fontScale também é travado no
// MainActivity; aqui cobre o WKWebView do iOS e o textZoom da WebView).
if (Capacitor.isNativePlatform()) {
  import("@capacitor/text-zoom")
      .then(({TextZoom}) => TextZoom.set({value: 1.0}))
      .catch((err) => console.warn("[TextZoom] lock falhou:", err?.message));
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// PWA service worker — descomente quando pronto para produção
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// serviceWorkerRegistration.register();
